/**
 *
 * Absence
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import moment from 'moment';

// styles
import './style.scss';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

import {
  flushStateAbsence,
  // list
  loadAbsences,
  changeAbsences,
  // one
  changeAbsence,
  deleteAbsence,
} from './actions';

import {
  selectAbsenceData,
  selectAbsenceLoading,
  selectAbsencesLoading,
  selectUpdatedAbsencesLoading,
  selectAbsenceError,
  selectAbsenceDeleteSuccessful,
  makeSelectItemsListFirstElem,
  makeSelectItemsList,
} from './selectors';

// antd component
import { Layout, Button, Tabs, Col, Row } from 'antd';
const { Content } = Layout;
const { TabPane } = Tabs;

//components
import CustomPageHeader from 'components/CustomPageHeader';
import CustomIcons from 'components/CustomIcons';
import TableAbsence from 'components/Absences/TableAbsence';
import AbsencesCard from 'components/Absences/AbsencesCard';
import InfoCard from 'components/InfoCard';
import Preloader from 'components/Preloader';

// global user
import { withUser } from 'engine/Contexts/User.context';

// utils
import {
  getAbsenceTypeLabel,
  getAbsenceStatusLabel,
  getAbsenceReason,
  getAbsenceDuration,
  getAbsenceMainDate,
  getAbsenceStartTime,
  getTypeList,
} from 'utils/helpers/helper.generateData';

import {
  DISPENSARY_PROGRAM,
  ACTIVITY_REASON,
  STATUSES_LIST,
} from 'utils/helpers/helper.constant';
import { sortByKey } from 'utils/helpers/helper.general';

function Absence({
  // main data
  itemsList,
  firstElem,
  absenceData,
  // states
  loadingUpdatedList,
  loadingData,
  deleteSuccessful,
  error,
  loading,
  history,
  user,
  // actions
  loadAbsences,
  changeAbsences,
  deleteAbsence,
  changeAbsence,
  flushState,
  //default
  className,
}) {
  useInjectReducer({ key: 'absence', reducer });
  useInjectSaga({ key: 'absence', saga });

  const newKey = 'nouvel';
  const timeFormat = 'HH:mm';
  const dateFormat = 'DD.MM.YYYY';

  const [absences, setAbsences] = useState([]);

  const [activeBtn, setActiveBtn] = useState(false);
  const [activeTab, setActiveTab] = useState('need-action');

  const [finished, setFinished] = useState([]);
  const [dataNoProcessed, setDataNoProcessed] = useState([]);
  const [allSelectedItem, setAllSelectedItem] = useState([]);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    !itemsList && loadAbsences();

    return () => {
      // Clearing the state after unmounting a component
      // Anything in here is fired on component unmount.
      flushState();
    };
  }, []);

  useEffect(() => {
    if (itemsList) {
      // TODO: -- Move it to backend
      const newData = itemsList?.data?.map(list => ({
        ...list,
        student: !!list?.student && ({
          ...list?.student,
          description: {
            ...list?.student?.description,
            fullname:
              list?.student?.description?.firstname +
              ' ' +
              list?.student?.description?.lastname,
          },
        })
      }));
      
      const finishedList = newData.filter(abs => {
        if (
          abs?.status == 'accepted' ||
          abs?.status == 'sickness-finish' ||
          abs?.status == 'refused'
        ) {
          return abs;
        }
      });

      setFinished(finishedList);
      const otherList = newData.filter(
        abs => !finishedList.includes(abs),
      );
      setDataNoProcessed(otherList);
      user.setAmountAbsence(otherList.length);
      setAbsences([...newData]);
    }
  }, [loading]);

  const handelClickCreateAbsence = () => {
    history.push(`/absences/${newKey}`);
  };

  const allSelectedItemUpd = (selectedRows, selected) => {
    setAllSelectedItem(selectedRows);
    setActiveBtn(selected);
  };

  const changeTab = key => {
    setActiveTab(key);
    setActiveBtn(false);
  };

  const setApproveSelection = () => {
    const dataFiltered = dataNoProcessed.filter(
      el => !allSelectedItem.includes(el),
    );

    setDataNoProcessed(dataFiltered);
    user.setAmountAbsence(dataFiltered.length);
    setFinished([...finished, ...allSelectedItem]);

    //action which will update data in database
    const prepeareList = allSelectedItem.map(selectedAbs => {
      let absObj = { ...selectedAbs };
      if (selectedAbs?.type == 'sickness') {
        absObj.status = 'sickness-finish';
      } else {
        absObj.status = 'accepted';
      }
      return absObj;
    });
    prepeareList && changeAbsences(prepeareList);
    setActiveBtn(false);
  };

  //data for columns
  //for columns Motif, Justificatif, Status testing data
  const columns = [
    {
      title: (
        <span className="column-title">
          <CustomIcons type="academic" className="icon-columns student" />
          Étudiant
        </span>
      ),
      dataIndex: ['student', 'description', 'fullname'],
      key: 'fullname',
      render: (text, record, index) => (
        <strong
          onClick={() => history.push(`/absences/${record.student?._id}`)}
        >
          {text}
        </strong>
      ),
      renderHighlight: (text, record, children) => (
        <strong
          onClick={() => history.push(`/absences/${record.student?._id}`)}
        >
          {children}
        </strong>
      ),
      search: true,
      ellipsis: true,
      sorter: (a, b) =>
        a.student.description.fullname.localeCompare(
          b.student.description.fullname,
        ),
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="users" className="icon-columns student" />
          Class
        </span>,
      ],
      dataIndex: ['student', 'class_info', 'title'],
      key: 'class_title',
      render: (text, record, index) => text,
      renderHighlight: (text, record, children) => children,
      search: true,
      ellipsis: true,
      sorter: (a, b) =>
        a.student.class_info.title.localeCompare(b.student.class_info.title),
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="quil" className="icon-columns type" />
          Type
        </span>,
      ],
      dataIndex: 'type',
      key: 'type',
      render: (text, record, index) => (
        <>
          {text == 'sickness' ? (
            <span className="title">{getAbsenceTypeLabel(text)}</span>
          ) : (
            <span className="title">Absence {getAbsenceTypeLabel(text)}</span>
          )}
        </>
      ),
      filters: getTypeList().map(type => ({
        value: type.value,
        text: type.label,
      })),
      onFilter: (value, record) => record.type == value,
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="quil" className="icon-columns reason" />
          Motif
        </span>,
      ],
      dataIndex: 'reason',
      key: 'reason',
      render: (text, record, index) => getAbsenceReason(record),
      filters: DISPENSARY_PROGRAM.concat(ACTIVITY_REASON)
        .map(reason => ({
          value: reason.value,
          text: reason.label,
        }))
        .sort(sortByKey('label')),
      onFilter: (value, record) => record.reason == value,
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="calendar" className="icon-columns date" />
          Date et heure
        </span>,
      ],
      dataIndex: 'date',
      key: 'date',
      render: (text, record, index) => {
        const mainDate = getAbsenceMainDate(record);
        const time = getAbsenceStartTime(record);
        return `${moment(mainDate).format('dd')}, ${moment(mainDate).format(
          dateFormat,
        )} ${time}`;
      },
      sorter: (a, b) => {
        const newA = new Date(getAbsenceMainDate(a));
        const newB = new Date(getAbsenceMainDate(b));

        if (newA < newB) return -1;

        if (newA > newB) return 1;

        return 0;
      },
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="time" className="icon-columns duration" />
          Durée
        </span>,
      ],
      dataIndex: 'duration',
      key: 'duration',
      render: (text, record, index) => getAbsenceDuration(record),
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="document" className="icon-columns proof" />
          Justificatif
        </span>,
      ],
      dataIndex: 'proof',
      key: 'media',
      render: (text, record, index) => {
        if (record?.media && record?.media.length > 0) {
          return 'inclus';
        } else {
          return 'non inclus ';
        }
      },
      filters: [
        { value: 'inclus', text: 'inclus' },
        { value: 'non-inclus', text: 'non inclus' },
      ],
      onFilter: (value, record) => {
        if (value == 'inclus') {
          return record?.media && record?.media.length > 0;
        } else {
          return record?.media && record?.media.length == 0;
        }
      },
    },
    {
      title: [
        <span className="column-title">
          <CustomIcons type="absence" className="icon-columns status" />
          Status
        </span>,
      ],
      dataIndex: 'status',
      key: 'status',
      render: (text, record, index) => getAbsenceStatusLabel(text),
      // !NOTE sorry for below code but coudn't know how to seperate it.
      filters: STATUSES_LIST.filter(status =>
        activeTab == 'need-action'
          ? !(
              status.value == 'accepted' ||
              status.value == 'sickness-finish' ||
              status.value == 'refused'
            )
          : status.value == 'accepted' ||
            status.value == 'sickness-finish' ||
            status.value == 'refused',
      ).map(status => ({
        value: status.value,
        text: status.label,
      })),
      onFilter: (value, record) => record.status == value,
    },
  ];
  
  // render function
  return (
    <Layout className="main-full-content">
      <Helmet>
        <title>Absence</title>
        <meta name="description" content="Description of Absence" />
      </Helmet>
      {loading && <Preloader />}
      {!loading && (
        <Content className="main-content-container absence-wrapper">
          <CustomPageHeader
            className="absence-header"
            title={'Absences'}
            subTitle={''}
            subTitlePosition="top"
            extraActions={[
              <Button
                className="box-new-create-btn"
                icon={<CustomIcons type="absence" />}
                onClick={handelClickCreateAbsence}
              >
                Nouvelle demande
              </Button>,
            ]}
          />

          <Row gutter={(15, 15)} className="absence-row">
            <Col sm={24} md={24} lg={12} xl={12}>
              <InfoCard title="Absence(s) à traiter">
                {dataNoProcessed.length}
              </InfoCard>
            </Col>
            <Col sm={24} md={24} lg={12} xl={12}>
              <AbsencesCard title="Heure(s) d’absence" absences={absences}>
                {dataNoProcessed.length}
              </AbsencesCard>
            </Col>
          </Row>

          <div className="absence-wrapper__content">
            {absences.length > 0 ? (
              <Button
                className={`tabs-approve-choice ${activeBtn ? 'active' : ''}`}
                disabled={!activeBtn}
                onClick={setApproveSelection}
              >
                Approuver la sélection
              </Button>
            ) : null}

            <Tabs
              className="absences-tabs"
              defaultActiveKey="need-action"
              activeKey={activeTab}
              onChange={changeTab}
            >
              <TabPane
                className={`tabs-btn`}
                tab={`Absences à traiter (${dataNoProcessed.length})`}
                key="need-action"
              >
                <TableAbsence
                  dataSource={dataNoProcessed}
                  dataColumns={columns}
                  activeTab={activeTab}
                  createAbsenceAction={handelClickCreateAbsence}
                  openFinishedAbsence={() => changeTab('finished')}
                  allSelectedItemUpd={allSelectedItemUpd}
                />
              </TabPane>
              <TabPane
                className={`tabs-btn`}
                tab="Absences traitées"
                key="finished"
              >
                <TableAbsence
                  dataSource={finished}
                  dataColumns={columns}
                  activeTab={activeTab}
                  createAbsenceAction={handelClickCreateAbsence}
                  allSelectedItemUpd={allSelectedItemUpd}
                />
              </TabPane>
            </Tabs>
          </div>
        </Content>
      )}
    </Layout>
  );
}

Absence.defaultProps = {
  loading: false,
};
Absence.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  loading: selectAbsencesLoading(),
  loadingData: selectAbsenceLoading(),
  loadingUpdatedList: selectUpdatedAbsencesLoading(),
  error: selectAbsenceError(),
  deleteSuccessful: selectAbsenceDeleteSuccessful(),
  absenceData: selectAbsenceData(),
  itemsList: makeSelectItemsList(),
  firstElem: makeSelectItemsListFirstElem(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushStateAbsence()),
    loadAbsences: () => dispatch(loadAbsences()),
    changeAbsences: list => dispatch(changeAbsences(list)),
    changeAbsence: data => dispatch(changeAbsence(data)),
    deleteAbsence: id => dispatch(deleteAbsence(id)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
  withUser,
)(Absence);
